<template>
    <section class="container px-0 pt-0 mt-3" v-if="topFeatures.length > 0">
        <div class="heading-box mb-3">
            <h2 class="h4 heading">Top Ausstattungs-Merkmale</h2>
        </div>

        <div class="d-none d-md-block px-3">
            <div class="row">
                <div class="mb-3 col-6 " v-for="feature in topFeatures">
                    <div class="d-flex align-items-stretch ">
                        <div class="feature-icon-box mr-3 text-center">
                            <img :src="feature.icon" :style="iconStyles" :alt="feature.title"
                                 class="mr-1 my-auto feature-icon" width="15px" v-if="feature.icon">
                        </div>

                        <div class="feature align-self-center">
                            {{ feature.title }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-left d-block d-md-none mt-3 px-3" style="position: relative">

            <div class="fader" v-if="!showAll && topFeatures.length > featuresBeforeFadeOut"></div>

            <transition name="fade">
                <div v-if="!showAll">
                    <div class="mb-3" v-for="(feature, index) in topFeatures" v-if="index <= featuresBeforeFadeOut">
                        <div class="d-flex align-items-stretch">
                            <div class="feature-icon-box mr-3 text-center">
                                <img :src="feature.icon" :style="iconStyles" :alt="feature.title"
                                     class="mr-1 my-auto feature-icon"
                                     width="15px" v-if="feature.icon">
                            </div>

                            <div class="feature align-self-center">
                                {{ feature.title }}
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else-if="showAll">
                    <div class="mb-3" v-for="(feature, index) in topFeatures">
                        <div class="d-flex align-items-stretch">
                            <div class="feature-icon-box mr-3 text-center">
                                <img :src="feature.icon" :style="iconStyles" :alt="feature.title"
                                     class="mr-1 my-auto feature-icon"
                                     width="15px" v-if="feature.icon">
                            </div>

                            <div class="feature align-self-center">
                                {{ feature.title }}
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <button class="show-more-button d-md-none btn-block" @click="showAll = !showAll"
                v-if="topFeatures.length > featuresBeforeFadeOut">
            <i :class="buttonIcon"></i>
            <strong><i>{{ buttonText }}</i></strong>
        </button>

    </section>
</template>

<script>
    export default {
        name: "topFeatures",
        props: {
            topFeatures: {
                type: Array,
                required: false,
                default: []
            }
        },
        data() {
            return {
                iconStyles: {
                    width: "100%"
                },
                showAll: false,
                featuresBeforeFadeOut: 4
            }
        },
        computed: {
            buttonIcon() {
                return this.showAll ? "fal fa-chevron-circle-up" : "fal fa-chevron-circle-down";
            },
            buttonText() {
                return this.showAll ? "verbergen" : "alles anzeigen";
            },
            shortenedFeatures(){
                let shortenedTopFeatures = this.topFeatures;
                return shortenedTopFeatures.splice(4);
            }
        }
    }
</script>

<style scoped lang="scss">
    .fader {
        position: absolute;
        height: 50px;
        width: 100%;
        bottom: 0;
        background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.5074404761904762) 50%, rgba(255, 255, 255, 0) 100%);
    }

    .feature {
        font-size: 0.875rem;
    }

    .heading-box {
        .heading {
            margin-bottom: 0;
        }
    }

    .feature-icon-box {
        width: 20px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }
</style>